import * as firebase from 'firebase'

const config = {
  // production
  apiKey: 'AIzaSyCTBor1L5T8Vhuk4BA4itVy7Z79GZMkk6o',
  authDomain: 'qraft-app.firebaseapp.com',
  databaseURL: 'https://qraft-app.firebaseio.com',
  projectId: 'qraft-app',
  storageBucket: 'qraft-app.appspot.com',
  messagingSenderId: '420773894725'
}
firebase.initializeApp(config)
firebase.firestore().settings({ timestampsInSnapshots: true })

export default firebase



// WEBPACK FOOTER //
// ./src/utils/firebase.ts